import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../ui/dialog';
import { FilaInterruptor } from './controles';

/** Preferencias del "…": valores por defecto de las preguntas nuevas (también están en Configuración). */
export default function DialogoPreferencias({ open, onOpenChange, ajustes, onGuardar }) {
  const [obligatorias, setObligatorias] = useState(false);
  const [puntos, setPuntos] = useState(0);

  useEffect(() => {
    if (!open) return;
    setObligatorias(!!ajustes?.obligatorias_por_defecto);
    setPuntos(ajustes?.cuestionario?.puntos_por_defecto ?? 0);
  }, [open, ajustes]);

  const guardar = () => {
    onGuardar({
      ...ajustes,
      obligatorias_por_defecto: obligatorias,
      cuestionario: { ...(ajustes?.cuestionario || {}), puntos_por_defecto: Math.max(0, Math.round(Number(puntos) || 0)) },
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="fe-dialogo max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle>Preferencias</DialogTitle>
          <DialogDescription>Se aplican a las preguntas que añadas a partir de ahora.</DialogDescription>
        </DialogHeader>
        <FilaInterruptor id="pref-obligatorias" titulo="Hacer obligatorias las preguntas" checked={obligatorias} onChange={setObligatorias} />
        <label className="fe-fila-ajuste" htmlFor="pref-puntos">
          <span className="fe-fila-ajuste-texto">
            <span className="fe-fila-ajuste-titulo">Valor de puntos predeterminado</span>
            <span className="fe-fila-ajuste-desc">Para cuestionarios.</span>
          </span>
          <input
            id="pref-puntos"
            type="number"
            min="0"
            inputMode="numeric"
            className="fe-input-caja fe-input-corto"
            value={puntos}
            onChange={(e) => setPuntos(e.target.value)}
          />
        </label>
        <div className="fe-dialogo-pie">
          <span className="flex-1" />
          <button type="button" className="fe-btn-borde" onClick={() => onOpenChange(false)}>Cancelar</button>
          <button type="button" className="fe-btn-primario" onClick={guardar}>Guardar</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
